import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { BankAccountResource } from "@exonn/js-sdk";

export const module: Module<BankAccountResource> = {
  id: ResourceEnum.BankAccount,
  bigIcon: <i className="icon-20-bank" />,
  smallIcon: <i className="icon-15-bank" />,
  name: (t: TFunction) => t("moduleName.bank-account"),

  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
